import {Component, DoCheck, EventEmitter, forwardRef, Input, IterableDiffers, OnChanges, Output, SimpleChange} from "@angular/core";
import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BasicList} from "./basic-list";
declare let $: any;


/**
 * Function > requiredValidator
 * @return {(c: FormControl) => {requiredError: {given: any; message: string}}}
 */
export function requiredValidator()
{
	return (c: FormControl) => {
		return (c.value.length == 0) ? true: null;
	};
}

export type compareFunction = (a: any, b: any) => number;
let nextId = 0;

@Component({
	selector: "tig-dual-list-box",
	styleUrls: ["./dual-list-box.component.css"],
	templateUrl: "./dual-list-box.component.html",
	providers: [
		{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DualListboxComponent), multi: true },
		{ provide: NG_VALIDATORS, useExisting: forwardRef(() => DualListboxComponent), multi: true }
	],
	// encapsulation: ViewEncapsulation.Emulated
})

export class DualListboxComponent implements DoCheck, OnChanges, ControlValueAccessor
{

	static AVAILABLE_LIST_NAME = 'available';
	static CONFIRMED_LIST_NAME = 'confirmed';

	static LTR = 'left-to-right';
	static RTL = 'right-to-left';

	static DEFAULT_FORMAT = {
		direction: DualListboxComponent.LTR,
		draggable: true,
		translate: {
			buttons: {
				assign: 'Assign',
				assign_all: 'Assign all',
				remove: 'Remove',
				remove_all: 'Remove all'
			},
			search: {
				available: 'Search under available',
				confirmed: 'Search under assigned'
			},
			all: 'All',
			none: 'None',
			order: 'order'
		},
	};

	propagateChange:any = () => {};
	validateFn:any = () => {};
	orderIdx: number = 0;

	@Input() id = `dual-list-${nextId++}`;
	// @Input() key = "_id";
	// @Input() display = "_name";
	// @Input() order = "_order";
	@Input() height = "100px";
	// @Input() filter = false;
	@Input() format = DualListboxComponent.DEFAULT_FORMAT;
	@Input() sort = true;
	@Input() compare: compareFunction;
	@Input() disabled = false;
	@Input() source: Array<any>;
	@Input() destination: Array<any>;
	// @Input() type: string = "sample1";
	@Input() config = {
		key: '_id',
		display: '_name',
		order: null,
		orderDrag: false,
		filter: false,
		sort: true,
		sortAttr: '_order',
		type: 'sample1',
		format: DualListboxComponent.DEFAULT_FORMAT
	};
	@Output() destinationChange = new EventEmitter();

	available: BasicList;
	confirmed: BasicList;

	dragElement: any;

	sourceDiffer: any;
	destinationDiffer: any;

	private sorter = (a: any, b: any) =>
	{
		let attr = this.config.sortAttr;
		return (a[attr] < b[attr]) ? -1 : ((a[attr] > b[attr]) ? 1 : 0);
	}

	constructor(private differs: IterableDiffers)
	{
		this.available = new BasicList(DualListboxComponent.AVAILABLE_LIST_NAME);
		this.confirmed = new BasicList(DualListboxComponent.CONFIRMED_LIST_NAME);
	}

	ngOnChanges(changeRecord: {[key: string]: SimpleChange})
	{

		if (typeof changeRecord.config === 'undefined')
		{
			this.destination = [];
			this.disabled = false;
			changeRecord.disabled = new SimpleChange(undefined, false, false);
			changeRecord.config = new SimpleChange(undefined, this.config, false);
		}

		if (changeRecord.config.currentValue.filter && changeRecord.config.currentValue.filter === false)
		{
			this.clearFilter(this.available);
			this.clearFilter(this.confirmed);
		}

		if (changeRecord.config.currentValue.sort)
		{
			if (changeRecord.config.currentValue.sort === true && this.compare === undefined)
			{
				this.compare = this.sorter;
			}
			else if (changeRecord.config.currentValue.sort === false)
			{
				this.compare = undefined;
			}
		}

		if (changeRecord.config.currentValue.format)
		{
			this.config.format = changeRecord.config.currentValue.format;

			if (typeof(this.config.format.direction) === "undefined")
			{
				this.config.format.direction = DualListboxComponent.LTR;
			}

			if (typeof(this.config.format.translate.buttons.assign) === "undefined")
			{
				this.config.format.translate.buttons.assign = DualListboxComponent.DEFAULT_FORMAT.translate.buttons.assign;
			}

			if (typeof(this.config.format.translate.buttons.assign_all) === "undefined")
			{
				this.config.format.translate.buttons.assign_all = DualListboxComponent.DEFAULT_FORMAT.translate.buttons.assign_all;
			}

			if (typeof(this.config.format.translate.buttons.remove) === "undefined")
			{
				this.config.format.translate.buttons.remove = DualListboxComponent.DEFAULT_FORMAT.translate.buttons.remove;
			}

			if (typeof(this.config.format.translate.buttons.remove_all) === "undefined")
			{
				this.config.format.translate.buttons.remove_all = DualListboxComponent.DEFAULT_FORMAT.translate.buttons.remove_all;
			}

			if (typeof(this.config.format.draggable) === "undefined")
			{
				this.config.format.draggable = DualListboxComponent.DEFAULT_FORMAT.draggable;
			}

			if (typeof(this.config.format.translate.all) === "undefined")
			{
				this.config.format.translate.all = DualListboxComponent.DEFAULT_FORMAT.translate.all;
			}

			if (typeof(this.config.format.translate.none) === "undefined")
			{
				this.config.format.translate.none = DualListboxComponent.DEFAULT_FORMAT.translate.none;
			}
		}

		if (changeRecord["source"])
		{
			this.available = new BasicList(DualListboxComponent.AVAILABLE_LIST_NAME);
			this.updatedSource();
			this.updatedDestination();
		}

		if (changeRecord["destination"])
		{
			this.confirmed = new BasicList(DualListboxComponent.CONFIRMED_LIST_NAME);
			this.updatedDestination();
			this.updatedSource();
		}
	}

	ngDoCheck()
	{
		if (this.source && this.buildAvailable(this.source))
		{
			this.onFilter(this.available);
		}
		if (this.destination && this.buildConfirmed(this.destination))
		{
			this.onFilter(this.confirmed);
		}
	}

	buildAvailable(source: Array<any>): boolean
	{
		const sourceChanges = this.sourceDiffer.diff(source);
		if (sourceChanges)
		{
			sourceChanges.forEachRemovedItem((r: any) => {
				const idx = this.findItemIndex(this.available.list, r.item, this.config.key);
				if (idx !== -1)
				{
					this.available.list.splice(idx, 1);
				}
			});

			sourceChanges.forEachAddedItem((r: any) =>
			{
				// Do not add duplicates even if source has duplicates.
				if (this.findItemIndex(this.available.list, r.item, this.config.key) === -1)
				{
					let item = {
						_id: this.makeId(r.item),
						_name: this.makeName(r.item)
					};
					if (typeof this.config.order !== 'undefined')
					{
						item['_order'] = this.makeOrder(r.item);
					}
					this.available.list.push(item);
				}
			});

			if (this.compare !== undefined)
			{
				this.available.list.sort(this.compare);
			}
			this.available.sift = this.available.list;

			return true;
		}
		return false;
	}

	buildConfirmed(destination: Array<any>): boolean
	{
		let moved = false;
		const destChanges = this.destinationDiffer.diff(destination);

		if (destChanges)
		{
			destChanges.forEachRemovedItem((r: any) =>
			{
				const idx = this.findItemIndex(this.confirmed.list, r.item, this.config.key);
				if (idx !== -1)
				{
					if (!this.isItemSelected(this.confirmed.pick, this.confirmed.list[idx]))
					{
						this.selectItem(this.confirmed.pick, this.confirmed.list[idx]);
					}

					this.moveItem(this.confirmed, this.available, this.confirmed.list[idx], false);
					moved = true;
				}
			});

			destChanges.forEachAddedItem((r: any) =>
			{
				const idx = this.findItemIndex(this.available.list, r.item, this.config.key);
				if (idx !== -1)
				{
					if (!this.isItemSelected(this.available.pick, this.available.list[idx]))
					{
						this.selectItem(this.available.pick, this.available.list[idx]);
					}
					this.moveItem(this.available, this.confirmed, this.available.list[idx], false);
					moved = true;
				}
			});

			if (this.compare !== undefined)
			{
				this.confirmed.list.sort(this.compare);
			}
			this.confirmed.sift = this.confirmed.list;

			if (moved)
			{
				this.trueUp();
			}
			return true;
		}
		return false;
	}

	updatedSource()
	{
		this.available.list.length = 0;
		this.available.pick.length = 0;

		if (this.source !== undefined)
		{
			this.sourceDiffer = this.differs.find(this.source).create(null);
		}
	}

	updatedDestination()
	{
		if (this.destination !== undefined)
		{
			this.destinationDiffer = this.differs.find(this.destination).create(null);
		}
	}

	direction()
	{
		return this.config.format.direction === DualListboxComponent.LTR;
	}

	dragEnd(list: BasicList = null)
	{
		if (list)
		{
			list.dragStart = false;
		}
		else
		{
			this.available.dragStart = false;
			this.confirmed.dragStart = false;
		}
		return false;
	}

	dragStart(event: DragEvent, item: any, list: BasicList)
	{
		if (!this.isItemSelected(list.pick, item))
		{
			this.selectItem(list.pick, item);
		}
		list.dragStart = true;

		// Set a custom type to be this dual-list"s id.
		event.dataTransfer.setData(this.id, item["_id"]);

		console.log(event);
		this.dragElement = {
			target: event.target,
			item: item
		};
	}


	/**
	 * @desc Event: dragover
	 * @param event: DragEvent
	 * @param list: BasicList
	 * @return boolean
	 */
	dragOver(event: DragEvent, list: BasicList): boolean
	{

		if (event.dataTransfer.types.length && (event.dataTransfer.types[0] === this.id))
		{
			event.preventDefault();
			let dragOverElement: any = event.target;
			if (!list.dragStart)
			{
				list.dragOver = true;
			}
			else if (this.config.orderDrag && list.name == 'confirmed' && (dragOverElement.nodeName == 'LABEL' || dragOverElement.nodeName == 'LI'))
			{
				if (dragOverElement.nodeName == 'LABEL')
				{
					dragOverElement = dragOverElement.parentElement;
				}

				if (this.isBefore(this.dragElement.target, dragOverElement))
				{
					$(this.dragElement.target).insertBefore(dragOverElement);
				}
				else
				{
					$(this.dragElement.target).insertBefore(dragOverElement.nextSibling);
				}
			}
		}
		return false;
	}

	dragLeave()
	{
		this.available.dragOver = false;
		this.confirmed.dragOver = false;
	}

	drop(event: DragEvent, list: BasicList)
	{
		if (event.dataTransfer.types.length && (event.dataTransfer.types[0] === this.id))
		{
			if (this.confirmed.dragOver)
			{
				this.moveItem(this.available, this.confirmed);

			}
			else if (this.available.dragOver)
			{
				this.moveItem(this.confirmed, this.available);
			}

			// drag and drop wanted
			if (this.config.orderDrag && list.name == 'available')
			{
				this.selectNone(this.confirmed);
				let children =  this.dragElement.target.parentElement.children;
				for (let i=0; children.length > i; i++)
				{
					// correct order at confirmed list and destination array
					this.setOrder(children[i].dataset.id, i+1);
				}
			}

			event.preventDefault();
			this.dragLeave();
			this.dragEnd();
		}
	}

	isBefore(a, b)
	{
		if (a.parentNode == b.parentNode)
		{
			for (let cur = a; cur; cur = cur.previousSibling)
			{
				if (cur === b)
				{
					return true;
				}
			}
		}
		return false;
	}

	private trueUp()
	{
		let changed = false;

		// Clear removed items.
		let pos = this.destination.length;
		while ((pos -= 1) >= 0)
		{
			const mv = this.confirmed.list.filter(conf =>
			{
				if (typeof this.destination[pos] === "object")
				{
					return conf._id === this.destination[pos][this.config.key];
				}
				else
				{
					return conf._id === this.destination[pos];
				}
			});
			if (mv.length === 0)
			{
				// Not found so remove.
				this.destination.splice(pos, 1);
				changed = true;
			}
		}

		// Push added items.
		for (let i = 0, len = this.confirmed.list.length; i < len; i += 1)
		{
			let mv = this.destination.filter((d: any) =>
			{
				if (typeof d === "object")
				{
					return (d[this.config.key] === this.confirmed.list[i]._id);
				}
				else
				{
					return (d === this.confirmed.list[i]._id);
				}
			});

			if (mv.length === 0)
			{
				// Not found so add.
				mv = this.source.filter((o: any) =>
				{
					if (typeof o === "object")
					{
						return (o[this.config.key] === this.confirmed.list[i]._id);
					}
					else
					{
						return (o === this.confirmed.list[i]._id);
					}
				});

				if (mv.length > 0)
				{
					this.destination.push(mv[0]);
					changed = true;
				}
			}
		}

		if (changed)
		{
			this.destinationChange.emit(this.destination);
		}
	}

	findItemIndex(list: Array<any>, item: any, key: any = "_id")
	{
		let idx = -1;

		function matchObject(e: any)
		{
			if (e._id === item[key])
			{
				idx = list.indexOf(e);
				return true;
			}
			return false;
		}

		function match(e: any)
		{
			if (e._id === item)
			{
				idx = list.indexOf(e);
				return true;
			}
			return false;
		}

		// Assumption is that the arrays do not have duplicates.
		if (typeof item === "object")
		{
			list.filter(matchObject);
		}
		else
		{
			list.filter(match);
		}

		return idx;
	}

	private makeUnavailable(source: BasicList, item: any)
	{
		const idx = source.list.indexOf(item);
		if (idx !== -1)
		{
			source.list.splice(idx, 1);
		}
	}

	moveItem(source: BasicList, target: BasicList, item: any = null, trueup = true)
	{
		let i = 0;
		let len = source.pick.length;

		if (item)
		{
			i = source.list.indexOf(item);
			len = i + 1;
		}

		for (; i < len; i += 1)
		{

			// Is the pick still in list?
			let mv: Array<any> = [];
			if (item)
			{
				const idx = this.findItemIndex(source.pick, item);
				if (idx !== -1)
				{
					mv[0] = source.pick[idx];
				}
			}
			else
			{
				mv = source.list.filter(src =>
				{
					return (src._id === source.pick[i]._id);
				});
			}

			// Should only ever be 1
			if (mv.length === 1)
			{
				// Add if not already in target.
				if (target.list.filter(trg => trg._id === mv[0]._id).length === 0)
				{
					// correct order at the destination
					let fi = this.destination.filter(dst =>
					{
						return (dst[this.config.key] === mv[0]._id );
					});
					if (fi.length > 0 && typeof fi[0][this.config.order] !== 'undefined')
					{
						mv[0]._order = fi[0][this.config.order];
					}
					// else if (item && typeof item[this.config.order] !== 'undefined')
					// {
					// 	mv[0]._order = item[this.config.order];
					// }
					target.list.push(mv[0]);
				}

				this.makeUnavailable(source, mv[0]);
			}
		}

		if (this.compare !== undefined)
		{
			target.list.sort(this.compare);
		}

		source.pick.length = 0;

		// Update destination
		if (trueup)
		{
			this.trueUp();
		}

		// Delay ever-so-slightly to prevent race condition.
		setTimeout(() =>
		{
			this.onFilter(source);
			this.onFilter(target);

			this.validateFn = requiredValidator();
			this.propagateChange(this.destination);
		}, 10);
	}

	isItemSelected(list: Array<any>, item: any)
	{
		if (list.filter(e => Object.is(e, item)).length > 0)
		{
			return true;
		}
		return false;
	}

	shiftClick(event: MouseEvent, index: number, source: BasicList, item: any)
	{
		if (event.shiftKey && source.last && !Object.is(item, source.last))
		{
			const idx = source.sift.indexOf(source.last);
			if (index > idx)
			{
				for (let i = (idx + 1); i < index; i += 1)
				{
					this.selectItem(source.pick, source.sift[i]);
				}
			}
			else if (idx !== -1)
			{
				for (let i = (index + 1); i < idx; i += 1)
				{
					this.selectItem(source.pick, source.sift[i]);
				}
			}
		}
		source.last = item;
	}

	selectItem(list: Array<any>, item: any)
	{
		const pk = list.filter((e: any) =>
		{
			return Object.is(e, item);
		});

		if (pk.length > 0)
		{
			// Already in list, so deselect.
			for (let i = 0, len = pk.length; i < len; i += 1)
			{
				const idx = list.indexOf(pk[i]);
				if (idx !== -1)
				{
					list.splice(idx, 1);
				}
			}
		}
		else
		{
			list.push(item);
		}
	}

	selectAll(source: BasicList)
	{
		source.pick.length = 0;
		source.pick = source.sift.slice(0);
	}

	selectNone(source: BasicList)
	{
		source.pick.length = 0;
	}

	isAllSelected(source: BasicList)
	{
		if (source.list.length === 0 || source.list.length === source.pick.length)
		{
			return true;
		}
		return false;
	}

	isAnySelected(source: BasicList)
	{
		if (source.pick.length > 0)
		{
			return true;
		}
		return false;
	}

	private unpick(source: BasicList)
	{
		for (let i = source.pick.length - 1; i >= 0; i -= 1)
		{
			if (source.sift.indexOf(source.pick[i]) === -1)
			{
				source.pick.splice(i, 1);
			}
		}
	}

	clearFilter(source: BasicList)
	{
		if (source)
		{
			source.picker = "";
			this.onFilter(source);
		}
	}

	onFilter(source: BasicList)
	{
		if (source.picker.length > 0)
		{
			const filtered = source.list.filter((item: any) =>
			{
				if (Object.prototype.toString.call(item) === "[object Object]")
				{
					if (item._name !== undefined)
					{
						return item._name.toLowerCase().indexOf(source.picker.toLowerCase()) !== -1;
					}
					else
					{
						return JSON.stringify(item).toLowerCase().indexOf(source.picker.toLowerCase()) !== -1;
					}
				}
				else
				{
					return item.toLowerCase().indexOf(source.picker.toLowerCase()) !== -1;
				}
			});
			source.sift = filtered;
			this.unpick(source);

		}
		else
		{
			source.sift = source.list;
		}
	}

	private makeId(item: any): string | number
	{
		if (typeof item === "object")
		{
			return item[this.config.key];
		}
		else
		{
			return item;
		}
	}

	// Allow for complex names by passing an array of strings.
	// Example: [display]="[ "_type.substring(0,1)", "_name" ]"
	private makeName(item: any): string
	{
		const display = this.config.display;

		function fallback(itm: any)
		{
			switch (Object.prototype.toString.call(itm))
			{
				case "[object Number]":
					return itm;
				case "[object String]":
					return itm;
				default:
					if (itm !== undefined)
					{
						return itm[display];
					}
					else
					{
						return "undefined";
					}
			}
		}

		let str = "";

		if (this.config.display !== undefined)
		{
			if (Object.prototype.toString.call(this.config.display) === "[object Array]")
			{
				for (let i = 0; i < this.config.display.length; i += 1)
				{
					if (str.length > 0)
					{
						str = str + "_";
					}

					if (this.config.display[i].indexOf(".") === -1)
					{
						// Simple, just add to string.
						str = str + item[this.config.display[i]];

					}
					else
					{
						// Complex, some action needs to be performed
						const parts = this.config.display[i].split(".");

						const s = item[parts[0]];
						if (s)
						{
							// Use brute force
							if (parts[1].indexOf("substring") !== -1)
							{
								const nums = (parts[1].substring(parts[1].indexOf("(") + 1, parts[1].indexOf(")"))).split(",");

								switch (nums.length)
								{
									case 1:
										str = str + s.substring(parseInt(nums[0], 10));
										break;
									case 2:
										str = str + s.substring(parseInt(nums[0], 10), parseInt(nums[1], 10));
										break;
									default:
										str = str + s;
										break;
								}
							}
							else
							{
								// method not approved, so just add s.
								str = str + s;
							}
						}
					}
				}
				return str;
			}
			else
			{
				return fallback(item);
			}
		}

		return fallback(item);
	}

	private makeOrder(item: any): string | number
	{
		if (typeof item === "object")
		{
			if (typeof item[this.config.order] === "undefined")
			{
				++this.orderIdx;
				return this.orderIdx;
			}
			else
			{
				return item[this.config.order];
			}
		}
		else
		{
			return item;
		}

	}

	/**
	 * Write a new value to the element.
	 * @see ControlValueAccessor
	 */
	writeValue(obj: any): void
	{
		if (obj)
		{
			this.destination = obj;
			this.updatedDestination();
		}
	}

	/**
	 * Set the function to be called when the control receives a change event.
	 * @see ControlValueAccessor
	 */
	registerOnChange(fn: any): void
	{
		this.propagateChange = fn;
	}

	/**
	 * Set the function to be called when the control receives a touch event.
	 * @see ControlValueAccessor
	 */
	registerOnTouched(fn: any): void {}

	/**
	 * This function is called when the control status changes to or from "DISABLED".
	 * Depending on the value, it will enable or disable the appropriate DOM element.
	 * @see ControlValueAccessor
	 *
	 * @param isDisabled
	 */
	setDisabledState?(isDisabled: boolean): void
	{
		console.log("setDisabledState(isDisabled)",isDisabled);
	}

	validate(c: FormControl)
	{
		return this.validateFn(c);
	}

	modelChange(event, target, item): void
	{
		if (event.length > 0)
		{
			item._order = +event;
			target.list.sort(this.compare);

			// correct order at destination array
			let fid = this.destination.filter(dst =>
			{
				return (dst[this.config.key] === item._id);
			});
			if (fid.length > 0)
			{
				fid[0][this.config.order] = item._order;
			}
			this.selectNone(target);
		}
	}


	/**
	 * @desc correct order at confirmed list and destination array
	 * @param id
	 * @param order
	 */
	setOrder(id: any, order: number): void
	{
		let fc = this.confirmed.list.filter(item =>
		{
			return (item._id == id);
		});
		if (fc.length > 0)
		{
			fc[0]._order = order;
		}
		let fd = this.destination.filter(item =>
		{
			return (item[this.config.key] == id);
		});
		if (fd.length > 0)
		{
			fd[0][this.config.order] = order;
		}
	}

}
